module.exports = __webpack_public_path__ + "static/media/black-dog.d63a6e9f.png";